import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { icons } from 'src/assets/icons/icons-config';

type Icon = {
  name: string;
  route: string;
};

@Injectable({
  providedIn: 'root',
})
export class IconService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly http = inject(HttpClient);
  private readonly sanitizer = inject(DomSanitizer);

  registerIcons(): void {
    icons.forEach((icon: Icon) => {
      this.iconRegistry.addSvgIcon(
        icon.name,
        this.sanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/${icon.route}.svg`,
        ),
      );
    });
  }
}
